import React, { useContext } from 'react'
import { Routes, Route } from 'react-router-dom'


import NotFound from '../NotFound'

import { AbilityContext } from '../../components/Ability'
import CreateCustomerBlackListPage from './Features/CustomerBlackList'


const CustomersPage = () => {
    const ability = useContext(AbilityContext)

    return (
        <Routes>
            <Route
                path="/black-list"
                element={
                    ability.can('manage', 'User', 'blackList') ? <CreateCustomerBlackListPage /> : <NotFound />
                }
            />
        </Routes>
    )
}

export default CustomersPage
